import { render, staticRenderFns } from "./icon-suffix.vue?vue&type=template&id=14c92377&"
import script from "./icon-suffix.vue?vue&type=script&lang=js&"
export * from "./icon-suffix.vue?vue&type=script&lang=js&"
import style0 from "./icon-suffix.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports